/**
 * Sumsub reject labels — the reason codes Sumsub returns on a rejected
 * verification, as the advisor reads them in the KYC widget and in the PDF
 * Sumsub block. Unknown codes are printed as given.
 */

import { pickT } from "../i18n";
import type { TranslationTable } from "../types/translation-table";

const SUMSUB_REJECT_LABELS: TranslationTable<Record<string, string>> = {
  en_GB: {
    // Bad Photo
    UNSATISFACTORY_PHOTOS: "Document photo is not readable or visible",
    GRAPHIC_EDITOR: "Image editing detected",
    SCREENSHOTS: "Screenshots are not accepted",
    // Bad Document
    BAD_PROOF_OF_IDENTITY: "Invalid identity document",
    DOCUMENT_DAMAGED: "Document is damaged or unreadable",
    REQUESTED_DATA_MISMATCH: "Document details do not match provided information",
    DIGITAL_DOCUMENT: "Digital document not accepted, original required",
    INCOMPATIBLE_LANGUAGE: "Document language not supported",
    EXPIRATION_DATE: "Document has expired or expires soon",
    ID_INVALID: "Identity document is invalid",
    INCOMPLETE_DOCUMENT: "Document is incomplete",
    // Bad Bank Card / Statement
    BAD_PROOF_OF_PAYMENT: "Invalid payment proof",
    // Data mismatch
    DATA_MISMATCH: "Data does not match",
    FRAUDULENT_PATTERNS: "Fraudulent patterns detected",
    FORGERY: "Document forgery detected",
    SPAM: "Spam detected",
    NOT_DOCUMENT: "Not a valid document",
    SELFIE_MISMATCH: "Selfie does not match document",
    LIVENESS_MISMATCH: "Liveness check failed",
  },
  nb_NO: {
    // Bad Photo
    UNSATISFACTORY_PHOTOS: "Dokumentfoto er ikke lesbart eller synlig",
    GRAPHIC_EDITOR: "Bilderedigering oppdaget",
    SCREENSHOTS: "Skjermbilder aksepteres ikke",
    // Bad Document
    BAD_PROOF_OF_IDENTITY: "Ugyldig identitetsdokument",
    DOCUMENT_DAMAGED: "Dokumentet er skadet eller uleselig",
    REQUESTED_DATA_MISMATCH: "Dokumentdetaljer samsvarer ikke med oppgitt informasjon",
    DIGITAL_DOCUMENT: "Digitalt dokument aksepteres ikke, original kreves",
    INCOMPATIBLE_LANGUAGE: "Dokumentspråk støttes ikke",
    EXPIRATION_DATE: "Dokumentet er utløpt eller utløper snart",
    ID_INVALID: "Identitetsdokumentet er ugyldig",
    INCOMPLETE_DOCUMENT: "Dokumentet er ufullstendig",
    // Bad Bank Card / Statement
    BAD_PROOF_OF_PAYMENT: "Ugyldig betalingsbevis",
    // Data mismatch
    DATA_MISMATCH: "Data samsvarer ikke",
    FRAUDULENT_PATTERNS: "Svindelmønstre oppdaget",
    FORGERY: "Dokumentforfalskning oppdaget",
    SPAM: "Spam oppdaget",
    NOT_DOCUMENT: "Ikke et gyldig dokument",
    SELFIE_MISMATCH: "Selfie samsvarer ikke med dokument",
    LIVENESS_MISMATCH: "Liveness-sjekk mislyktes",
  },
};

export function getSumsubRejectLabel(label: string, lang: string): string {
  return pickT(SUMSUB_REJECT_LABELS, lang)[label] ?? label;
}
